import { render, staticRenderFns } from "./GuppyChatSidebarSetting.vue?vue&type=template&id=0d0d1444&scoped=true"
import script from "./GuppyChatSidebarSetting.vue?vue&type=script&lang=js"
export * from "./GuppyChatSidebarSetting.vue?vue&type=script&lang=js"
import style0 from "./GuppyChatSidebarSetting.vue?vue&type=style&index=0&id=0d0d1444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0d1444",
  null
  
)

export default component.exports